export default "__VITE_ASSET__DiZQCslu__"